export default __webpack_public_path__ + "static/media/chart.23e4dd08.svg";